import { useEffect, useRef, useState } from "react";
import { animate, useInView } from "framer-motion";
import { STATS } from "@/data/content";
import { Reveal } from "@/components/Reveal";

const Counter = ({ to }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-40px" });
  const [val, setVal] = useState(0);

  useEffect(() => {
    if (!inView) return;
    const controls = animate(0, to, {
      duration: 2.2,
      ease: [0.22, 1, 0.36, 1],
      onUpdate: (v) => setVal(Math.round(v)),
    });
    return () => controls.stop();
  }, [inView, to]);

  return <span ref={ref}>{val.toLocaleString("en-IN")}</span>;
};

export default function Stats() {
  return (
    <section
      className="border-y border-white/10 bg-zinc-950/60 backdrop-blur-xl"
      data-testid="stats-section"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-2 lg:grid-cols-4">
        {STATS.map((s, i) => (
          <Reveal
            key={s.label}
            delay={i * 0.1}
            className={`py-12 md:py-16 px-4 md:px-8 ${
              i !== 0 ? "border-l border-white/10" : ""
            }`}
          >
            <p
              className="font-heading text-4xl md:text-6xl font-bold text-sky-400 tracking-tight"
              data-testid={`stat-value-${i}`}
            >
              <Counter to={s.value} />
              {s.suffix}
            </p>
            <p className="mt-3 text-sm uppercase tracking-[0.2em] text-zinc-400">
              {s.label}
            </p>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
